<button
  class="button is-family-semiBold"
  [ngClass]="[isLoading() ? 'is-loading' : '', styleClass()]"
  [innerHTML]="text()"
  [type]="buttonType()"
  [disabled]="disabled()">
</button>
